import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import RemoveIcon from '@mui/icons-material/Remove';

const PathCard = (props) => {
	const index = props.index;
	const kc = props.kc;
	const onAdd = props.onAdd;
	const onRemove = props.onRemove;
	const section = props.section;
	const id = props.id;
	const subtopic = kc.subtopics?.find((s) => s.id === kc.subtopicId);
	const progress = subtopic ? subtopic.progress : 0;
	const mastery = progress === 100 ? 'High' : progress > 60 ? 'Medium' : 'Low';
	return (
		<Card
			key={index}
			variant="outlined"
			sx={{
				minWidth: 350,
				maxWidth: 350,
				padding: 2,
				display: 'flex',
				flexDirection: 'row',
				minHeight: '8.45rem',
				maxHeight: '8.45rem',
			}}
		>
			<CardContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					width: '67%',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						// mb: '1',
						flexDirection: 'column',
						height: '100%',
						textAlign: 'left',
					}}
				>
					{/* <Typography variant="subtitle1" fontWeight="bold">
						{kc.title}
					</Typography> */}
					<Box>
						<p
							style={{
								display: '-webkit-box',
								WebkitLineClamp: 3,
								WebkitBoxOrient: 'vertical',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								fontFamily: 'Helvetica',
								fontSize: '1rem',
								// color: 'white',
								margin: 0,
								textAlign: 'start',
								width: '100%',
								height: '100%', // Ensures line clamping respects height
								whiteSpace: 'break-spaces',
							}}
						>
							{kc.title}
						</p>
					</Box>
					<Chip
						label={mastery}
						color="error"
						size="small"
						sx={{ width: 'fit-content', marginTop: '0.5rem' }}
					/>
				</Box>

				{/* <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      {kc.progress[0]}% → {kc.progress[1]}% → {kc.progress[2]}%
                    </Typography> */}

				{/* <Stack direction="row" spacing={2} mt={1}>
					<Button
						variant="contained"
						startIcon={<SearchIcon />}
						size="small"
						sx={{ backgroundColor: '#1a237e' }}
					>
						Learn
					</Button>
					<Button
						variant="contained"
						startIcon={<PlayArrowIcon />}
						size="small"
						sx={{ backgroundColor: '#1a237e' }}
					>
						Quiz
					</Button>
					<Button
						variant="contained"
						startIcon={<AssignmentIcon />}
						size="small"
						sx={{ backgroundColor: '#1a237e' }}
					>
						Flashcards
					</Button>
				</Stack> */}
			</CardContent>
			<Box
				sx={{
					width: '40%',
					height: 'auto',
					alignItems: 'center',
					display: 'flex',
					justifyContent: 'center',
				}}
			>
				<CircularProgressbar
					value={progress}
					text={`${progress}%`}
					strokeWidth={15}
					styles={buildStyles({
						pathColor: progress === 100 ? 'green' : progress > 60 ? '#48b7ff' : 'red',
						textColor: 'black',
					})}
				/>
			</Box>
			<Box
				sx={{
					height: 'auto',
					width: 'fit-content',
					justifyContent: 'start',
					alignItems: 'end',
					display: 'flex',
					flexDirection: 'column',
					marginLeft: '0.5rem',
				}}
			>
				<AddIcon
					sx={{ color: '#1F21E6' }}
					onClick={() => onAdd(section)}
					fontSize="small"
				/>
				<RemoveIcon
					sx={{ color: '#1F21E6' }}
					onClick={() => onRemove(id, section)}
					fontSize="small"
				/>
			</Box>
		</Card>
	);
};

export default PathCard;
